module.exports = __webpack_public_path__ + "static/media/im1.c962b6a3.png";